// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    width: 60vw; /* Ширина контейнера таблицы */
    margin: 0 auto; /* Центрирование по горизонтали */
}

/* Стили для таблицы */
table {
    width: 100%; /* Ширина таблицы */
    border-collapse: collapse; /* Сворачивание границ */
}

th, td {
    width: 20vw; /* Ширина столбцов */
    border: 1px solid #828282; /* Границы ячеек */
    padding: 8px; /* Отступ внутри ячеек */
    text-align: center; /* Выравнивание текста по центру */
    color: #828282; /* Цвет текста */
}

/* Кнопка "Добавить" */
.add-button {
    background-color: #FFEB39; /* Цвет фона кнопки */
    border: none; /* Удаление границы кнопки */
    padding: 10px; /* Отступы внутри кнопки */
    border-radius: 5px; /* Закругление углов */
    cursor: pointer; /* Изменение курсора при наведении */
    margin-top: 20px; /* Отступ сверху */
}

/* Модальное окно */
.modal {
    display: flex !important;
    flex-direction: column;
    position: fixed; /* Фиксированное положение */
    top: 50%; /* Положение сверху на 50% */
    left: 50%; /* Положение слева на 50% */
    transform: translate(-50%, -50%); /* Центрирование модального окна */
    background-color: #FFF; /* Цвет фона */
    border: 1px solid #000; /* Граница */
    padding: 20px; /* Отступ внутри модального окна */
    border-radius: 10px; /* Закругление углов */
    width: 30vw;
    height: -moz-fit-content;
    height: fit-content;
    gap: 10px;
}

/* Кнопка "Сохранить" в модальном окне */
.save-button {
    background-color: #FFEB39; /* Цвет фона кнопки */
    border: none; /* Удаление границы кнопки */
    padding: 10px; /* Отступы внутри кнопки */
    border-radius: 5px; /* Закругление углов */
    cursor: pointer; /* Изменение курсора при наведении */
}`, "",{"version":3,"sources":["webpack://./src/components/personal/discounts.css"],"names":[],"mappings":"AAAA;IACI,WAAW,EAAE,8BAA8B;IAC3C,cAAc,EAAE,iCAAiC;AACrD;;AAEA,sBAAsB;AACtB;IACI,WAAW,EAAE,mBAAmB;IAChC,yBAAyB,EAAE,wBAAwB;AACvD;;AAEA;IACI,WAAW,EAAE,oBAAoB;IACjC,yBAAyB,EAAE,kBAAkB;IAC7C,YAAY,EAAE,wBAAwB;IACtC,kBAAkB,EAAE,kCAAkC;IACtD,cAAc,EAAE,gBAAgB;AACpC;;AAEA,sBAAsB;AACtB;IACI,yBAAyB,EAAE,qBAAqB;IAChD,YAAY,EAAE,4BAA4B;IAC1C,aAAa,EAAE,0BAA0B;IACzC,kBAAkB,EAAE,sBAAsB;IAC1C,eAAe,EAAE,oCAAoC;IACrD,gBAAgB,EAAE,kBAAkB;AACxC;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;IACxB,sBAAsB;IACtB,eAAe,EAAE,4BAA4B;IAC7C,QAAQ,EAAE,4BAA4B;IACtC,SAAS,EAAE,2BAA2B;IACtC,gCAAgC,EAAE,kCAAkC;IACpE,sBAAsB,EAAE,cAAc;IACtC,sBAAsB,EAAE,YAAY;IACpC,aAAa,EAAE,kCAAkC;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA,wCAAwC;AACxC;IACI,yBAAyB,EAAE,qBAAqB;IAChD,YAAY,EAAE,4BAA4B;IAC1C,aAAa,EAAE,0BAA0B;IACzC,kBAAkB,EAAE,sBAAsB;IAC1C,eAAe,EAAE,oCAAoC;AACzD","sourcesContent":[".table-container {\r\n    width: 60vw; /* Ширина контейнера таблицы */\r\n    margin: 0 auto; /* Центрирование по горизонтали */\r\n}\r\n\r\n/* Стили для таблицы */\r\ntable {\r\n    width: 100%; /* Ширина таблицы */\r\n    border-collapse: collapse; /* Сворачивание границ */\r\n}\r\n\r\nth, td {\r\n    width: 20vw; /* Ширина столбцов */\r\n    border: 1px solid #828282; /* Границы ячеек */\r\n    padding: 8px; /* Отступ внутри ячеек */\r\n    text-align: center; /* Выравнивание текста по центру */\r\n    color: #828282; /* Цвет текста */\r\n}\r\n\r\n/* Кнопка \"Добавить\" */\r\n.add-button {\r\n    background-color: #FFEB39; /* Цвет фона кнопки */\r\n    border: none; /* Удаление границы кнопки */\r\n    padding: 10px; /* Отступы внутри кнопки */\r\n    border-radius: 5px; /* Закругление углов */\r\n    cursor: pointer; /* Изменение курсора при наведении */\r\n    margin-top: 20px; /* Отступ сверху */\r\n}\r\n\r\n/* Модальное окно */\r\n.modal {\r\n    display: flex !important;\r\n    flex-direction: column;\r\n    position: fixed; /* Фиксированное положение */\r\n    top: 50%; /* Положение сверху на 50% */\r\n    left: 50%; /* Положение слева на 50% */\r\n    transform: translate(-50%, -50%); /* Центрирование модального окна */\r\n    background-color: #FFF; /* Цвет фона */\r\n    border: 1px solid #000; /* Граница */\r\n    padding: 20px; /* Отступ внутри модального окна */\r\n    border-radius: 10px; /* Закругление углов */\r\n    width: 30vw;\r\n    height: fit-content;\r\n    gap: 10px;\r\n}\r\n\r\n/* Кнопка \"Сохранить\" в модальном окне */\r\n.save-button {\r\n    background-color: #FFEB39; /* Цвет фона кнопки */\r\n    border: none; /* Удаление границы кнопки */\r\n    padding: 10px; /* Отступы внутри кнопки */\r\n    border-radius: 5px; /* Закругление углов */\r\n    cursor: pointer; /* Изменение курсора при наведении */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
